import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import brouch1 from "../../assets/images/brouch1.webp";
import amps from "../../assets/images/amps.webp";
import nicholas from "../../assets/images/nicholas.png";

const Bouchers = () => {
  const dataContext = useContext(AuthContext);
  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`w-full px-6 sm:px-10 md:px-20 transition-all duration-500 ${
        theme === "dark" ? "bg-white text-black" : "bg-black text-white"
      }`}
    >
      <div className=" max-w-[1536px] mx-auto transition-all duration-500">
        {/* Brochure Section */}
        <h1
          className={`font-bold bricolage-grotesque-bold flex justify-center items-center  md:mb-3 py-4 text-center transition-all duration-500 ${
            theme === "dark" ? "text-black" : "text-white"
          } text-[28px] sm:text-[36px] md:text-[44px] lg:text-[52px]`}
        >
          Brochures
        </h1>

        <p
          className={`font-semibold bricolage-grotesque-semibold flex justify-center items-center mb-3 md:py-2 text-center transition-all duration-500 ${
            theme === "dark" ? "text-gray-800" : "text-white"
          } text-[16px] sm:text-[18px] md:text-[22px] lg:text-[26px]`}
        >
          Culinary Construction
        </p>

        <div className="flex justify-center items-center">
          <img src={brouch1} alt="Brochure" className="w-full" />
        </div>

        {/* AMPS Section */}
        <div className=" max-w-[1536px] mx-auto">
          <button
            className={`font-semibold bricolage-grotesque-semibold rounded-2xl px-4 py-2 my-3 md:my-10 md:mb-10 mx-auto block transition-all duration-500 ${
              theme === "dark"
                ? "text-black bg-[#d9d9d9]"
                : "text-white bg-[#232323]"
            } text-[16px] sm:text-[18px] md:text-[22px] lg:text-[26px]`}
          >
            AMPS
          </button>

          <div className="flex justify-center items-center">
            <img src={amps} alt="AMPS" className="w-full" />
          </div>
        </div>

        {/* Nicholas Section */}
        <div className="max-w-[1536px] mx-auto">
          <button
            className={`font-semibold bricolage-grotesque-semibold rounded-2xl px-4 py-2 my-3 md:my-10 md:mb-10 mx-auto block transition-all duration-500 ${
              theme === "dark"
                ? "text-black bg-[#d9d9d9]"
                : "text-white bg-[#232323]"
            } text-[16px] sm:text-[18px] md:text-[22px] lg:text-[26px]`}
          >
            NICHOLAS CHALARIS
          </button>

          <div className="flex justify-center items-center">
            <img src={nicholas} alt="Nicholas Chalaris" className="w-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bouchers;
